import styled from 'styled-components';
import { flexBoxCenter } from 'shared/styles/commonStyles';

const HeatingPlatformMain = () => {
  return (
    <EmptyWrapper>
      <EmptyTitle>Heating platform data unavailable</EmptyTitle>
    </EmptyWrapper>
  );
};

export default HeatingPlatformMain;

const EmptyWrapper = styled.section`
  width: 100%;
  min-height: 320px;
  ${flexBoxCenter}
`;

const EmptyTitle = styled.span`
  font-size: 16px;
  color: var(--text-muted);
`;
